import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
} from '@/components/ui/dialog';
import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';

interface ModalSummaryProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  handleCancelAndReschedule: () => void;
}

export function BookedAppointment({
  open,
  onOpenChange,
  handleCancelAndReschedule,
}: ModalSummaryProps) {
  const [data, setData] = useState<{
    date: string;
    time: string;
    doctor: string;
    appointmentId: string;
  } | null>(null);

  useEffect(() => {
    const formDataObject = {
      date: 'Friday, 6th August',
      time: '09:30 am - 10:00 am',
      doctor: 'Dr. Naini',
      appointmentId: '23SAMPLE',
    };

    setData(formDataObject);
  }, []);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <div>
          <DialogTitle className="text-xl font-bold mb-2">
            Booked Appointment
          </DialogTitle>
          <DialogClose asChild />
          <div className="flex gap-3 mb-10">
            <p className="text-md font-semibold">{data?.date}</p>
            <p className="text-md font-semibold">{data?.time}</p>
          </div>

          <div className="mb-32">
            <p className="text-xl mb-2 font-semibold">{data?.doctor}</p>
            <p className="text-xl font-semibold">
              Appointment ID: {data?.appointmentId}
            </p>
          </div>

          <div className="flex justify-between mt-4">
            <Button variant="black" onClick={handleCancelAndReschedule}>
              Cancel and Reschedule
            </Button>
            <Button variant="black">Cancel and Refund</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
